import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import shadow from '../../helpers/shadow';

export default function DashboardCard({
  title,
  titleSize,
  action,
  content,
  noBorder,
  isGrid,
  cardActions,
  shadowMd,
  rawTitle,
}) {
  const useStyles = makeStyles()(theme => ({
    root: {
      backgroundColor: theme.palette.background.card,
      borderRadius: 16,
      boxShadow: shadowMd ? shadow.md : shadow.xl,
      margin: isGrid ? '2em 2em  2em 0' : undefined,
    },
    header: {
      backgroundColor: theme.palette.background.card,
    },
  }));

  const { classes } = useStyles();

  return (
    <Card className={rawTitle ? 'tw-w-full ' + classes.root : classes.root}>
      {rawTitle ? (
        <>
          {rawTitle}
          <Divider />
        </>
      ) : (
        <>
          <div className="pl-2 pr-2">
            <CardHeader
              className={classes.header}
              title={
                <Typography
                  color="textPrimary"
                  variant={titleSize || 'h6'}
                  compomnent="h1"
                  className="p-0"
                >
                  <Box fontWeight="fontWeightBold">{title}</Box>
                </Typography>
              }
              action={<div className="mt-2">{action}</div>}
            />
          </div>
          <Divider />
        </>
      )}
      <div className="p-2">
        {noBorder && content}
        {!noBorder && <CardContent>{content}</CardContent>}
      </div>
      {cardActions && <CardActions>{cardActions}</CardActions>}
    </Card>
  );
}
